export default __webpack_public_path__ + "e6aeee6257d1c7b9a8f43bff58fbdc52.svg";